import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	unresolved: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	unresolved: {
		id: 'native-issue-table.common.issue-cells.resolution.unresolved',
		defaultMessage: 'Unresolved',
		description: 'Displayed string when resolution is unresolved',
	},
});
export default messages;
